import { Button, Empty, Loading, Title } from "@components";
import { If } from "@components/control-statements";
import FlowFoldersDrawer from "@containers/flows/FlowFoldersDrawer";
import FlowFoldersList from "@containers/flows/FlowFoldersList";
import { FlowFormDrawer } from "@containers/flows/FlowFormDrawer";
import { FlowList } from "@containers/flows/FlowList";
import { FlowAPI } from "@providers/FlowAPI";
import styles from "@styles/pages/flow/FlowList.module.scss";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { OlgaEnvironmentsAPI } from "../../providers/OlgaEnvironmentsAPI";

import classNames from "classnames/bind";
import { GodMode } from "shared/core/GodMode";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const FLOW_LIST_STYLE = {
	grid: "grid",
	table: "table",
};

export default function Fluxos() {
	const [loadingFlows, setLoadingFlows] = useState(true);
	const [showNewDrawer, setShowNewDrawer] = useState(false);
	const [showNewFolderDrawer, setShowNewFolderDrawer] = useState(false);
	const [flows, setFlows] = useState([]);
	const [folders, setFolders] = useState([]);
	const [flowStyle, setFlowStyle] = useState(FLOW_LIST_STYLE.grid);

	useEffect(() => {
		loadMyFlows();
	}, []);

	const loadMyFlows = async () => {
		setLoadingFlows(true);
		const myFlowsResponse = await FlowAPI.getFlows();
		setFlows(myFlowsResponse.getData([]));
		loadFolders();
	};

	const loadFolders = async () => {
		const environmentConfigurations =
			await OlgaEnvironmentsAPI.getConfigurations();
		const folders = environmentConfigurations.getData({})?.flow_folders || [];
		setFolders(folders);
		setLoadingFlows(false);
	};

	const importFlows = async () => {

		const input = document.createElement('input');
		input.type = 'file';
		input.accept = ".csv";

		input.onchange = e => {
			const file = e.target.files[0];

			// setting up the reader
			const reader = new FileReader();
			reader.readAsText(file, 'UTF-8');
			reader.onload = async (reader_event) => {
				const content = reader_event.target.result;

				const confirmed = await window.confirm({
					text: "Você tem certeza que deseja aplicar esse arquivo?",
					confirmText: "Sim",
					cancelText: "Cancelar",
				});

				if (!confirmed) {
					return false;
				}

				// Realizar o upload do arquivo
				setLoadingFlows(true);
				const response = await FlowAPI.importFlows(Environment.id, content);
				setLoadingFlows(false);

				if (response.getErrors([]).length > 0) {
					alert({ text: response.getErrors()[0], buttonText: "Ok" });
				} else {
					alert({ text: "Processo de importação agendado", buttonText: "Ok" });
				}
			}
		}

		input.click();

	};

	const navigate = useNavigate();

	const ToggleListStyle = ({ selectedStyle, onChange }) => {
		return (
			<div className={styles.toggle}>
				<div
					className={css({
						side: true,
						active: selectedStyle === FLOW_LIST_STYLE.grid,
					})}
					onClick={() => onChange(FLOW_LIST_STYLE.grid)}
				>
					<i className="fal fa-grid" />
				</div>
				<div
					className={css({
						side: true,
						active: selectedStyle === FLOW_LIST_STYLE.table,
					})}
					onClick={() => onChange(FLOW_LIST_STYLE.table)}
				>
					<i className="fal fa-list" />
				</div>
			</div>
		);
	};

	return (
		<>
			<If cond={isMobile}>
				<Empty>
					<p>Essa página não está disponível para dispositivos móveis</p>
				</Empty>
			</If>

			<If cond={loadingFlows}>
				<div className="w-100 d-flex align-center justify-center flex-1 pt-25 pb-25">
					<Loading />
				</div>
			</If>

			<If cond={!isMobile && !loadingFlows}>
				<Title title="Meus fluxos" backTo={{ url: "/fidelizacao-e-marketing", name: "Fidelização e Marketing" }}>
					<If cond={flows.length > 0 || folders.length > 0}>
						<ToggleListStyle
							selectedStyle={flowStyle}
							onChange={(s) => setFlowStyle(s)}
						/>
					</If>
					{folders.length === 0 && (
						<Button
							design="two"
							className={"ml-15"}
							icon
							onClick={() => navigate(`/fluxos/arquivados`)}
						>
							<i className="fal fa-box-archive" />
						</Button>
					)}
					<Button
						design="two"
						className={"ml-15"}
						icon
						onClick={() => setShowNewFolderDrawer(true)}
					>
						<i className="fal fa-folder-open" />
					</Button>

					<If cond={flows.length > 0 || folders.length > 0}>
						<Button
							className={"ml-15"}
							design="primary"
							onClick={() => setShowNewDrawer(true)}
						>
							Adicionar fluxo
						</Button>
					</If>
					
					<If cond={GodMode.isGodMode}>
						<Button
							className={"ml-15"}
							design="primary"
							onClick={() => importFlows()}
						>
							Importar planilha de fluxos
						</Button>
						<Button
							className={"ml-15"}
							design="primary"
							onClick={() => navigate(`/fluxos/criacao`) }
						>
							Criar fluxos
						</Button>
					</If>
				</Title>

				<If cond={folders.length > 0}>
					<FlowFoldersList folders={folders} />
				</If>

				<If cond={flows.length > 0 && !loadingFlows && folders.length > 0}>
					<p className={styles.label}>Desagrupados ({flows.length})</p>
				</If>

				<If cond={flows.length === 0 && folders.length === 0 && !loadingFlows}>
					<Empty>
						<i className="far fa-arrows-split-up-and-left"></i>
						<p>Não há fluxos configurados.</p>
						<span>
							Através dessa ferramenta, será possível configurar fluxos no Olga.
						</span>
						<Button design="primary" onClick={() => setShowNewDrawer(true)}>
							Iniciar um novo fluxo
						</Button>
					</Empty>
				</If>

				<FlowList
					flows={flows}
					onFlowClick={(flow) => {
						navigate(`/fluxos/${flow.id}`);
					}}
					flowStyle={flowStyle}
					onLoadFlows={() => loadMyFlows()}
				/>
				<FlowFormDrawer
					folders={folders}
					visible={showNewDrawer}
					onClose={() => setShowNewDrawer(false)}
					onSaved={(newFlow) => {
						navigate(`/fluxos/${newFlow.id}`);
					}}
				/>
				<FlowFoldersDrawer
					visible={showNewFolderDrawer}
					onClose={() => {
						setShowNewFolderDrawer(false);
						loadFolders();
					}}
					onLoadFolders={() => loadFolders()}
					onLoadFlows={() => loadMyFlows()}
				/>
			</If>
		</>
	);
}
